module.exports = __webpack_public_path__ + "img/logo5.23650979.png";